export const iconFontAwesomeDisasterCrisisHouseFire = (
	<i className="fa-solid fa-house-fire"></i>
);
